import koLocale from "element-ui/lib/locale/lang/ko";

const ko = {
  register: {
    test: "棒子",
  },
  ...koLocale,
};
export default ko;
